import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "ui-card__title" }, "Add Custom Field", -1)
const _hoisted_2 = { class: "flex gap-4" }
const _hoisted_3 = { class: "flex gap-4" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "w-full" }, null, -1)
const _hoisted_5 = { class: "flex flex-col gap-2" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "px-4 flex flex-col gap-2" }
const _hoisted_8 = { class: "flex gap-4 justify-center" }

import {
	Dialog,
	SelectOption,
	UiInput,
	UiSelect,
	SvgIcon,
	UiButton,
	UiForm,
	useForm
} from '@/ui-kit';
import { Nullable, uuid } from '@/utils';
import { useToggle } from '@vueuse/core';
import { required } from '@vuelidate/validators';
import {
	FieldType,
	readableFieldType,
	useCustomFields
} from '../composition/use-custom-fields';
import { computed } from 'vue';
import CustomFieldDropdownOption from './CustomFieldDropdownOption.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AddCustomFieldDialog',
  setup(__props, { expose }) {

const [isOpened, setIsOpened] = useToggle();

function randomId() {
	return uuid(6);
}

const { groups, createField } = useCustomFields();
const { loading, onSubmit, resetForm, formData } = useForm(
	{
		group_id: 0,
		name: '',
		type: '',
		options: [] as { value: string; id: string }[]
	},
	{
		group_id: {
			required
		},
		name: {
			required
		},
		type: {
			required
		}
	}
);

expose({
	openDialog: (group_id: Nullable<number>) => {
		resetForm({
			group_id,
			name: '',
			type: '',
			options: []
		});
		setIsOpened(true);
	}
});

const groupOptions = computed<SelectOption[]>(() => {
	return groups.value.map((group) => ({
		title: group.name,
		value: group.id
	}));
});

const fieldTypeOptions = computed<SelectOption[]>(() => {
	return [
		'text',
		'date',
		'datetime',
		'dropdown',
		'list_box',
		'integer'
	].map((value) => ({
		title: readableFieldType(value as FieldType),
		value
	}));
});

function setOptions(type: FieldType) {
	if (type === 'list_box' || type === 'dropdown') {
		formData.options = [
			{ value: 'Option 1', id: randomId() },
			{ value: 'Option 2', id: randomId() }
		];
	} else {
		formData.options = [];
	}
}

function removeOption(id: string) {
	formData.options = formData.options.filter(
		(item) => item.id !== id
	);
}

const submitForm = onSubmit(async (data) => {
	await createField({
		...data,
		order: (
			groups.value.find(
				(group) => group.id === data.group_id
			)?.fields || []
		).length,
		options: data.options.map((option, i) => ({
			name: option.value,
			order: i
		}))
	}).then(() => setIsOpened(false));
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Dialog), {
    modelValue: _unref(isOpened),
    "onUpdate:modelValue": _unref(setIsOpened),
    preventDefaultClose: _unref(loading)
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(UiForm), {
        class: "p-4 flex flex-col gap-4",
        onSubmit: _unref(submitForm)
      }, {
        default: _withCtx(() => [
          _hoisted_1,
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_unref(UiInput), {
              class: "w-full",
              label: "Field Name",
              placeholder: "Field Name",
              modelValue: _unref(formData).name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(formData).name) = $event)),
              name: "name"
            }, null, 8, ["modelValue"]),
            _createVNode(_unref(UiSelect), {
              class: "w-full",
              label: "Group",
              placeholder: "Select Group",
              modelValue: _unref(formData).group_id,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(formData).group_id) = $event)),
              options: _unref(groupOptions),
              name: "group_id"
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(UiSelect), {
              class: "w-full",
              label: "Field Type",
              placeholder: "Select Field Type",
              modelValue: _unref(formData).type,
              "onUpdate:modelValue": [
                _cache[2] || (_cache[2] = ($event: any) => ((_unref(formData).type) = $event)),
                _cache[3] || (_cache[3] = ($event: any) => (setOptions($event)))
              ],
              options: _unref(fieldTypeOptions),
              name: "type"
            }, null, 8, ["modelValue", "options"]),
            _hoisted_4
          ]),
          _createElementVNode("div", _hoisted_5, [
            (_unref(formData).options.length)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, " Options "))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(formData).options, (option, i) => {
                return (_openBlock(), _createBlock(CustomFieldDropdownOption, {
                  onRemoveItem: ($event: any) => (
							removeOption(option.id)
						),
                  key: option.id,
                  modelValue: option.value,
                  "onUpdate:modelValue": ($event: any) => ((option.value) = $event),
                  index: i,
                  canDelete: 
							_unref(formData).options.length > 2
						,
                  disabled: _unref(loading)
                }, null, 8, ["onRemoveItem", "modelValue", "onUpdate:modelValue", "index", "canDelete", "disabled"]))
              }), 128))
            ]),
            (
						_unref(formData).type === 'dropdown' ||
						_unref(formData).type === 'list_box'
					)
              ? (_openBlock(), _createBlock(_unref(UiButton), {
                  key: 1,
                  type: "button",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (
						_unref(formData).options.push({
							value: `Option ${
								_unref(formData).options.length + 1
							}`,
							id: randomId()
						})
					)),
                  class: "!text-xs !h-8 !min-w-28 !w-28 !px-0",
                  theme: "primary-outlined"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(SvgIcon), {
                      name: "only-plus",
                      class: "h-4 w-4 mr-1"
                    }),
                    _createTextVNode(" Add option ")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_unref(UiButton), {
              type: "button",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(setIsOpened)(false))),
              class: "!h-10 text-sm !min-w-32 !w-32",
              theme: "secondary",
              disabled: _unref(loading)
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Cancel ")
              ]),
              _: 1
            }, 8, ["disabled"]),
            _createVNode(_unref(UiButton), {
              class: "!h-10 text-sm !min-w-32 !w-32",
              theme: "primary",
              loading: _unref(loading)
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Add Field ")
              ]),
              _: 1
            }, 8, ["loading"])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit"])
    ]),
    _: 1
  }, 8, ["modelValue", "onUpdate:modelValue", "preventDefaultClose"]))
}
}

})